import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = (props) => {
    return (
        <Body Color={props.Color} Width={props.Width} Height={props.Height} onClick={props.onClick} marginBottom={props.marginBottom} >
            {props.icon}{props.text}
        </Body>
    );
}

export { Button };

Button.propTypes = {
    Color: PropTypes.string.isRequired,
    Width: PropTypes.string,
    Height: PropTypes.string,
    text: PropTypes.string.isRequired,
    icon: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    marginBottom: PropTypes.string,
};

const Body = styled.div`
    background-color: ${props => props.Color};
    color: #fff;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: ${props => props.Height ? props.Height : "20px"};
    margin: 0 10px ;
    margin-bottom: ${props => props.marginBottom ? props.marginBottom : "0px"};
    width: ${props => props.Width ? "calc("+props.Width+" - 20px)" : "auto"};
    height: ${props => props.Height ? props.Height : "auto"};

    display: flex;
    justify-content: center;
    align-items: center;
    i {
        margin-right: 5px;
    }
`;
